export const initializeInputs = () => {
    initializeCurrencyInputs();
    initializePercentageInputs();
    initializeDateTimeInputs();
    initializeTextFieldInputs();
    initializeAutoCompleteInputs();
    initializePhoneInputs();
}

const initializeCurrencyInputs = () => {
    const $currencyInputs = $('input.js-currency');
    $.each($currencyInputs, (index, element) => {
        const $element = $(element);
        if (!$element.length || $element.data('kendoNumericTextBox')) return;

        try {
            $element.css('text-align', 'right');
            $element.kendoNumericTextBox({
                format: 'c2',
                spinners: $element.data('spinner') || false
            });
        }catch(e){
            console.error(e);
        }
    });
}

const initializePercentageInputs = () => {
    const $currencyInputs = $('input.js-percentage');

    $.each($currencyInputs, (index, element) => {
        const $element = $(element);
        if ($element.data('kendoNumericTextBox')) return;

        let decimals = $element.data('decimals') || 2;
        let decimalStrings = '';
        while (decimals > 0) {
            decimalStrings += '0';
            decimals--;
        }
        try {
            $element.css('text-align', 'right');
            $element.kendoNumericTextBox({
                format: `##,#.${decimalStrings} \\%`,
                spinners: $element.data('spinner') || false
            });
        }catch(e){
            console.error(e);
        }
    });
}

const initializeDateTimeInputs = () => {
    const $dateTimes = $('input.js-datepicker');

    $.each($dateTimes, (index, element) => {
        const $element = $(element);
        if ($element.data('kendoDatePicker')) return;

        $element.kendoDatePicker({
            format: 'MM/dd/yyyy'
        });
    });
}

const initializeTextFieldInputs = () => {
    const $textFields = $('input.js-textfield');

    $.each($textFields, (index, element) => {
        const $element = $(element);
        if ($element.data('kendoTextArea')) return;

        let options = {};

        const characterLimit = $element.data('char-limit');
        if (characterLimit) {
            options.maxLength = characterLimit;
        }

        $element.kendoTextArea(options);
    });
}

const initializeAutoCompleteInputs = () => {
    const $autoCompletes = $('input.js-autocomplete');

    $.each($autoCompletes, (index, element) => {
        const $element = $(element);
        if ($element.data('kendoAutoComplete')) return;

        $element.kendoAutoComplete({});
    });
}

const initializePhoneInputs = () => {
    const $autoCompletes = $('input.js-phone');

    $.each($autoCompletes, (index, element) => {
        const $element = $(element);
        if ($element.data('kendoMaskedTextBox')) return;

        $element.kendoMaskedTextBox({
            mask: "(000) 000-0000"
        });
    });
}

const initializeEmailInputs = () => {
    const $autoCompletes = $('input.js-email');

    $.each($autoCompletes, (index, element) => {
        const $element = $(element);
        if ($element.data('kendoTextBox')) return;

        $element.kendoTextBox();
    });
}